/*** IMPORTS FROM imports-loader ***/
var define = false;

// import external dependencies
import 'core-js';
import 'jquery';
import 'picturefill';
import 'lazysizes';
import 'slick-carousel/slick/slick';
import './util/custom.ls.bgset'; // Custom implementation of 'lazysizes/plugins/bgset/ls.bgset'

// Import everything from autoload


// import local dependencies
import './util/polyfills';
import Router from './util/Router';
import common from './routes/common';
import gradShowPage from './routes/gradShowPage';
import author from './routes/author';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // grad show page - includes home page
  gradShowPage,

  // Student details page
  author,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

